import { createSlice } from '@reduxjs/toolkit';
// import {logoutRequest} from "../../services/authRequest";

const userData = () => {
  const data = localStorage.getItem('user');
  try {
    return data ? JSON.parse(data) : null;
  } catch (e) {
    return null;
  }
};
const userSlice = createSlice({
  name: 'user',
  initialState: {
    isLoggedIn: !!userData(),
    info: userData(),
    isLoad: false,
    code: [],
  },
  reducers: {
    setLogin: (state, action) => {
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.isLoggedIn = true;
      state.info = action.payload;
    },
    setAuthUpdate: (state, action) => {
      // Ưu tiên token mới từ API, fallback token cũ nếu không có
      const newData = {
        ...state.info,
        ...action.payload,
      };
      localStorage.setItem('user', JSON.stringify(newData));
      state.info = newData;
    },
    setLogout: (state) => {
      localStorage.removeItem('user');
      state.isLoggedIn = false;
      state.info = null;
      state.code = [];
    },
    setCode: (state, action) => {
      state.code = action.payload;
    },
    setAppLoading: (state, action) => {
      state.isLoad = action.payload;
    },
    // Cập nhật toàn bộ user data sau refresh session
    setSessionRefresh: (state, action) => {
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.isLoggedIn = true;
      state.info = action.payload;
    },
  },
});

const { actions, reducer } = userSlice;
export const { setLogin, setLogout, setCode, setAppLoading, setAuthUpdate, setSessionRefresh } = actions;
export default reducer;
